// Tiny EventSource wrapper that re-instantiates on the named event types
// emitted by the backend's live broadcaster. The browser's built-in
// reconnect handles transient drops, so we only forward parsed events.

export type BoardEvent =
  | "question_added"
  | "question_approved"
  | "question_rejected"
  | "vote_count_changed"
  | "question_answered"
  | "state_changed";

export function subscribeToBoard(
  sessionId: string,
  onEvent: (type: BoardEvent, data: Record<string, unknown>) => void,
): () => void {
  const url = `/api/v1/sessions/${sessionId}/stream`;
  const es = new EventSource(url);

  const types: BoardEvent[] = [
    "question_added",
    "question_approved",
    "question_rejected",
    "vote_count_changed",
    "question_answered",
    "state_changed",
  ];
  const listeners: { type: BoardEvent; handler: (e: MessageEvent) => void }[] = [];
  for (const t of types) {
    const handler = (e: MessageEvent) => {
      try {
        onEvent(t, JSON.parse(e.data));
      } catch {
        // ignore malformed event
      }
    };
    es.addEventListener(t, handler as EventListener);
    listeners.push({ type: t, handler });
  }

  return () => {
    for (const { type, handler } of listeners) {
      es.removeEventListener(type, handler as EventListener);
    }
    es.close();
  };
}
